export const matchesSearch = (keywords: string[], search: string): boolean => {
  for (const keyword of keywords) {
    if (keyword.toLowerCase().trim().includes(search.toLowerCase().trim())) {
      return true
    }
  }

  return false
}
